import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getJobChatMessages } from "../actions/jobChats.actions";
import { jobChatsQueryKeys } from "../jobChats.queryKeys";

export const useJobChatMessagesQuery = ({ jobEventUid, companyId, pageSize = 20, enabled = true }) => {
  const token = sessionStorage.getItem("token");
  const activeCompanyId = useSelector((state: any) => state.userState.activeCompanyId);
  const effectiveCompanyId = companyId ?? activeCompanyId;

  const queryOptions = useMemo(
    () => ({
      queryKey: jobChatsQueryKeys.messages(effectiveCompanyId, jobEventUid),
      queryFn: async ({ pageParam = 1 }) =>
        getJobChatMessages(token, jobEventUid, { page: pageParam, pageSize, order: "DESC", companyId: effectiveCompanyId }),
      getNextPageParam: (lastPage) => {
        const page = Number(lastPage?.page);
        const total = Number(lastPage?.totalPages);
        if (!page || !total || page >= total) return undefined;
        return page + 1;
      },
      initialPageParam: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: 0,
      gcTime: 0,
      enabled: Boolean(token && effectiveCompanyId && jobEventUid) && enabled,
    }),
    [token, effectiveCompanyId, jobEventUid, pageSize, enabled]
  );

  const messagesQuery = useInfiniteQuery(queryOptions);

  return { messagesQuery, activeCompanyId: effectiveCompanyId };
};
